import { useAppDispatch, useAppSelector } from "../../../store";
import { useGetABOProfileQuery } from "../../../services/AboProfile/AboProfileAPI";
import SSIUplineProfileView from "./SSIUplineProfileView";
import { closeProfileModal } from "../../../reducers/ssiUplineReport";

export default function SSIUplineProfile() {
  const { aboNo, affNo, sponsorNo, sponsorAff, eligibilityWindow, showEligibilityWindow, show, previousElementID } =
    useAppSelector((state) => state.ssiUplineReportTracker.ssiUplineProfileProps);

  const dispatch = useAppDispatch();

  const closeProfile = () => {
    dispatch(closeProfileModal());
    if (previousElementID) {
      setTimeout(() => document.getElementById(previousElementID)?.focus(), 0);
    }
  };

  const {
    isFetching: aboDataFetching,
    isError,
    data: aboData,
  } = useGetABOProfileQuery(
    {
      aff: affNo,
      abo: aboNo,
    },
    { skip: !show },
  );

  const { isFetching: sponsorDataFetching, data: sponsorData } = useGetABOProfileQuery(
    {
      aff: sponsorAff,
      abo: sponsorNo,
    },
    { skip: !show },
  );

  return (
    <SSIUplineProfileView
      aboNo={aboNo}
      affNo={affNo}
      sponsorNo={sponsorNo}
      sponsorAff={sponsorAff}
      eligibilityWindow={eligibilityWindow}
      showEligibilityWindow={showEligibilityWindow}
      show={show}
      aboDataFetching={aboDataFetching}
      sponsorDataFetching={sponsorDataFetching}
      aboData={aboData}
      sponsorData={sponsorData}
      isError={isError}
      onCloseClick={closeProfile}
    />
  );
}
